export default __webpack_public_path__ + "static/media/总磷分析仪.0a063a78.png";